import controller from './doctor-or-condition-selector.controller';
import template from './doctor-or-condition-selector.html';

let DoctorOrConditionSelectorComponent = {
	bindings: {
		doctorOrConditionList: '<',
		minCharacter: '<',
		activateOnFocus: '<',
		searchFields: '<',
		language: '<',
		onSelect: '&'
	},
	controller,
	template
};

export default DoctorOrConditionSelectorComponent;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-or-condition-selector/doctor-or-condition-selector.component.js